import { buildApiUrl } from '../config';
import useAPI from '../../hooks/useAPI';
import { FortnoxImportRun } from '../../models/FortnoxImportRun';
import { FortnoxIntegrationType } from '../../types/backendTypes/FortnoxIntegrationType';
import { ErrorTypes } from '../../types/backendResponses/ErrorTypes';
import { ApiError } from '../../types/ApiError';

/**
 * Starts an import from Fortnox. The backend answers as soon as the import job has started; the
 * run is then followed with useGetFortnoxImportRun.
 *
 * When an import is already running for the integration type, the backend answers Conflict with
 * that run's id, which is returned instead so the caller follows the running import.
 */
export const useStartFortnoxImport = () => {
  const { callAPI } = useAPI<FortnoxImportRun>({ method: 'POST' }, [ErrorTypes.Conflict]);

  const action = async (
    integrationType: FortnoxIntegrationType,
    full = false
  ): Promise<FortnoxImportRun | { runningRunId: string }> => {
    try {
      return (await callAPI(buildApiUrl(`fortnoxImport/integrationType/${integrationType}`), {
        full,
      })) as FortnoxImportRun;
    } catch (error) {
      const data = (error as ApiError)?.response?.data;
      const runningRunId = (data?.metadata as { runId?: string } | undefined)?.runId;
      if (data?.status === ErrorTypes.Conflict && runningRunId) {
        return { runningRunId };
      }
      throw error;
    }
  };

  return { action };
};
